import { StatCard } from "@/components/shared/PagePrimitives";
import { formatMoneyCompact, formatMoney, plur } from "@/lib/format";

// KPI pruh Skladu (§6). Šest kachlí přes StatCard. Částky se renderují jen když
// hodnota != null — MANAGER (bez cen) dostane počty místo korun.
export function WarehouseKpis({ kpis, money, activeFilter, onFilter, onQueue, testid = "warehouse-kpis" }) {
  const m = (v) => (v == null ? "—" : formatMoneyCompact(v));
  const full = (v) => (v == null ? undefined : formatMoney(v));

  const tiles = money ? [
    { label: "Hodnota zásob", value: m(kpis.stock_value), title: full(kpis.stock_value),
      sub: plur(kpis.stock_items || 0, "položka", "položky", "položek") },
    { label: "Čeká na naskladnění", value: m(kpis.queue_value), title: full(kpis.queue_value),
      sub: `${plur(kpis.queue_lines || 0, "položka", "položky", "položek")} · zaplaceno, není převzato`,
      onClick: onQueue, testid: "kpi-queue" },
    { label: "Vydáno na stavby", value: m(kpis.issued_30d), title: full(kpis.issued_30d),
      sub: "za posledních 30 dní" },
    { label: "Odpisy a manka", value: m(kpis.writeoff_30d), title: full(kpis.writeoff_30d),
      sub: `${kpis.writeoff_pct || 0} % z výdeje`, danger: (kpis.writeoff_30d || 0) > 0 },
    { label: "Dochází", value: String(kpis.low_count ?? 0),
      sub: "pod minimální zásobou — klepni pro výpis", onClick: () => onFilter("low"),
      active: activeFilter === "low", testid: "kpi-low" },
    { label: "Ležáky bez pohybu", value: m(kpis.dead_value), title: full(kpis.dead_value),
      sub: `${plur(kpis.dead_count || 0, "položka", "položky", "položek")} · klepni pro výpis`,
      onClick: () => onFilter("dead"), active: activeFilter === "dead", testid: "kpi-dead" },
  ] : [
    { label: "Položek na skladě", value: String(kpis.stock_items ?? 0) },
    { label: "Čeká na naskladnění", value: String(kpis.queue_lines ?? 0),
      sub: "není převzato", onClick: onQueue, testid: "kpi-queue" },
    { label: "Vydáno na stavby", value: String(kpis.issued_30d_count ?? 0), sub: "za 30 dní (počet)" },
    { label: "Odpisy a manka", value: String(kpis.writeoff_30d_count ?? 0), sub: "za 30 dní (počet)",
      danger: (kpis.writeoff_30d_count || 0) > 0 },
    { label: "Dochází", value: String(kpis.low_count ?? 0), sub: "pod minimem",
      onClick: () => onFilter("low"), active: activeFilter === "low", testid: "kpi-low" },
    { label: "Ležáky bez pohybu", value: String(kpis.dead_count ?? 0), sub: "bez pohybu",
      onClick: () => onFilter("dead"), active: activeFilter === "dead", testid: "kpi-dead" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2.5" data-testid={testid}>
      {tiles.map((t, i) => (
        <StatCard key={i} label={t.label} value={t.value} sub={t.sub} title={t.title}
          danger={t.danger} active={t.active} onClick={t.onClick}
          valueClass={t.danger ? "text-destructive" : undefined}
          testid={t.testid || `kpi-tile-${i}`} />
      ))}
    </div>
  );
}
